import { defineComponent as b, ref as p, inject as T, computed as C, createElementBlock as l, openBlock as r, normalizeStyle as A, normalizeClass as H, createElementVNode as x, Fragment as g, renderList as B, createVNode as F, createCommentVNode as R } from "vue";
import { JSONtoNaiveVars as L } from "./highrise343.mjs";
import M from "./highrise251.mjs";
import { KEYCODE as i } from "./highrise490.mjs";
import { getInputOtpSizeStyles as V } from "./highrise491.mjs";
import w from "./highrise492.mjs";
import { COMPONENT_NAME as K } from "./highrise178.mjs";
const W = ["id"], $ = { class: "hr-input-otp__fields" }, G = {
  key: 0,
  class: "hr-input-otp__separator"
}, J = b({
  name: K.INPUT_OTP
}), ne = /* @__PURE__ */ b({
  ...J,
  props: {
    fields: {
      type: Number,
      default: 6
    },
    disabled: {
      type: Boolean
    },
    placeholder: {
      type: String,
      default: "0"
    },
    size: {
      type: String
    },
    status: {
      type: String,
      default: "default"
    },
    separatorPosition: {
      type: Number,
      default: void 0
    },
    id: {
      type: String,
      default: void 0
    }
  },
  emits: ["onComplete", "onChange"],
  setup(a, { emit: S }) {
    const D = M("InputOtp"), s = a, n = p([]), f = p([]), t = p(0), m = S, c = (e) => {
      f.value = Object.assign([], n.value), n.value[t.value] = e, f.value.join("") !== n.value.join("") && (m("onChange", n.value.join("")), O());
    }, u = (e) => {
      t.value = Math.max(Math.min(s.fields - 1, e), 0);
    }, v = () => {
      u(t.value + 1);
    }, h = () => {
      u(t.value - 1);
    }, N = (e) => {
      c(e), v();
    }, _ = (e) => {
      switch (e.keyCode) {
        case i.BACKSPACE:
          e.preventDefault(), c(""), h();
          break;
        case i.DELETE:
          e.preventDefault(), c("");
          break;
        case i.LEFT_ARROW:
          e.preventDefault(), h();
          break;
        case i.RIGHT_ARROW:
          e.preventDefault(), v();
          break;
      }
    }, k = (e) => {
      e.preventDefault();
      const d = e.clipboardData.getData("text/plain").slice(0, s.fields - t.value).split("");
      if (!d.join("").match(/^\d+$/))
        return D.value.invalidPastedData;
      const o = n.value.slice(0, t.value).concat(d);
      n.value = o.slice(0, s.fields), u(o.slice(0, s.fields).length), O();
    }, E = (e) => {
      t.value = e;
    }, I = () => {
      t.value = -1;
    }, O = () => {
      const e = n.value.join("");
      e.length === s.fields && m("onComplete", {
        otp: e,
        state: "completed"
      });
    }, P = T("hr-form", "md"), z = C(() => s.size || P), j = C(() => {
      const e = V(z.value);
      return L(e);
    });
    return (e, d) => (r(), l("div", {
      id: a.id,
      class: H(["hr-input-otp__container", [`hr-input-${a.status}`]]),
      style: A(j.value)
    }, [
      x("div", $, [
        (r(!0), l(g, null, B(a.fields, (y, o) => (r(), l(g, { key: y }, [
          F(w, {
            focus: t.value === o,
            value: n.value[o],
            disabled: a.disabled,
            placeholder: a.placeholder,
            onOnChange: N,
            onOnKeydown: _,
            onOnPaste: k,
            onOnFocus: (U) => E(o),
            onOnBlur: I
          }, null, 8, ["focus", "value", "disabled", "placeholder", "onOnFocus"]),
          a.separatorPosition === o + 1 ? (r(), l("div", G)) : R("", !0)
        ], 64))), 128))
      ])
    ], 14, W));
  }
});
export {
  ne as default
};
